<template>
  <div style="overflow-x: auto;overflow-y: hidden;">
    <v-card class="pa-6 ma-6 mb-0" v-if="!isTeacherUser" outlined>
      <div class="filter-wrapper">
        <div class="filter-options">
          <v-row>
            <v-col cols="12">
              <CheckboxAcademicLevel :isDefaultCheckAll="false" @change="academicLevelChanged" />
            </v-col>
            <v-col cols="12" md="6">
              <AutocompleteSubjectGroup
                v-model="subjectGroup"
                clear-icon="mdi-close"
                label="Lĩnh vực"
                item-text="title"
                outlined
                dense
                return-object
                hide-details
                @change="subjectGroupChanged"
              />
            </v-col>
            <v-col cols="12" md="6">
              <AutocompleteTeacherCard
                :syncedValue.sync="teacher"
                item-text="name"
                clear-icon="mdi-close"
                label="Giáo viên"
                outlined
                dense
                deletable-chips
                hide-details
                :displaySubjectGroup="true"
                :filter="teacherFilter"
              />
            </v-col>
          </v-row>
        </div>
        <div class="filter-submit">
          <v-btn
            class="search-button"
            height="40"
            color="#0D47A1"
            @click="getTeacherSlots"
            :disabled="!teacher || !teacher.id"
            outlined
          >
            Chọn xem
          </v-btn>
        </div>
      </div>
    </v-card>
    <TimeTableBlankView type="teacher" v-if="!selectedTeacherId && !isTeacherUser" class="ma-6" />
    <TimeTableTable :selectedTeacherId="selectedTeacherId" :slots="teacherSlots" type="teacher" />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import TimeTableTable from '@/modules/timeTable/TimeTableTable.vue'
import AutocompleteTeacherCard from '@/components/basic/input/AutocompleteTeacherCard'
import TimeTableBlankView from '@/modules/timeTable/TimeTableBlankView.vue'
import AutocompleteSubjectGroup from '@/components/basic/input/AutocompleteSubjectGroup'
import CheckboxAcademicLevel from '@/modules/academicLevel/CheckboxAcademicLevel.vue'

import { isEmpty, get } from 'lodash'

export default {
  components: {
    TimeTableTable,
    TimeTableBlankView,
    AutocompleteTeacherCard,
    AutocompleteSubjectGroup,
    CheckboxAcademicLevel
  },
  data() {
    return {
      grade: null,
      dialog: false,
      selected: null,
      classData: null,
      tab: null,
      teacher: null,
      selectedTeacherId: '',
      selectedClassFromClass: '',
      createState: false,
      subjectGroup: {},
      academicLevels: []
    }
  },
  computed: {
    ...mapState('timeTable', ['classSlots', 'teacherSlots']),
    ...mapGetters('auth', ['profile', 'role']),

    teacherFilter() {
      if (Array.isArray(this.academicLevels) && this.academicLevels.length) {
        return {
          academicLevels_in: this.academicLevels.map(a => a.id),
          subjectGroup: get(this.subjectGroup, 'id')
        }
      }

      return { subjectGroup: get(this.subjectGroup, 'id') }
    },
    tabIsFullHeight() {
      return !(
        (this.tab === 0 && !isEmpty(this.selectedClassFromClass)) ||
        (this.tab === 1 && !isEmpty(this.selectedTeacherId))
      )
    },
    isTeacherUser() {
      return this.role.type === 'teacher'
    }
  },
  async mounted() {
    if (this.isTeacherUser) {
      this.selectedTeacherId = this.profile.id
      this.setSelectedTeacherId(this.selectedTeacherId)
      await this.fetchTeacherSlots({ teacher: this.selectedTeacherId })
    }
  },
  methods: {
    ...mapActions('timeTable', ['fetchClassSlots', 'fetchTeacherSlots', 'removeSlot', 'setSelectedTeacherId']),
    academicLevelChanged(academicLevels) {
      this.academicLevels = academicLevels
      this.teacher = null
    },
    subjectGroupChanged(subjectGroup) {
      this.subjectGroup = subjectGroup
      if (subjectGroup && subjectGroup.id) {
        this.teacher = null
      }
    },
    async getTeacherSlots() {
      this.selectedTeacherId = get(this.teacher, 'id', '')
      this.setSelectedTeacherId(this.selectedTeacherId)

      if (this.selectedTeacherId) {
        await this.fetchTeacherSlots({ teacher: this.selectedTeacherId })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
